import React, { useState, useEffect, memo } from 'react';
import { Phone, MessageCircle } from 'lucide-react';
import { companyInfo } from '../data/mock';

const FloatingButtons = memo(() => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(null);

  useEffect(() => {
    // Show buttons immediately
    setIsVisible(true);
  }, []);

  const handleCall = () => {
    window.location.href = `tel:${companyInfo.phones[0]}`;
  };

  const handleWhatsApp = () => {
    const whatsappNumber = companyInfo.whatsapp.replace(/[^0-9]/g, '');
    const message = encodeURIComponent('Hello! I would like to inquire about your diagnostic services.');
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, '_blank');
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3">
      {/* WhatsApp Button */}
      <div className="relative">
        <button
          onClick={handleWhatsApp}
          onMouseEnter={() => setShowTooltip('whatsapp')}
          onMouseLeave={() => setShowTooltip(null)}
          className="w-14 h-14 bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full shadow-lg flex items-center justify-center"
          aria-label="Chat on WhatsApp"
        >
          <MessageCircle size={28} fill="white" />
        </button>
        {showTooltip === 'whatsapp' && (
          <div className="absolute right-16 top-1/2 -translate-y-1/2 bg-gray-900 text-white px-3 py-2 rounded-lg text-sm whitespace-nowrap">
            Chat on WhatsApp
          </div>
        )}
      </div>

      {/* Call Button - Completely static, no animations */}
      <div className="relative">
        <button
          onClick={handleCall}
          onMouseEnter={() => setShowTooltip('call')}
          onMouseLeave={() => setShowTooltip(null)}
          className="w-14 h-14 bg-[#007897] hover:bg-[#006680] text-white rounded-full shadow-lg flex items-center justify-center"
          aria-label="Call Us"
        >
          <Phone size={28} />
        </button>
        {showTooltip === 'call' && (
          <div className="absolute right-16 top-1/2 -translate-y-1/2 bg-gray-900 text-white px-3 py-2 rounded-lg text-sm whitespace-nowrap">
            Call: {companyInfo.phones[0]}
          </div>
        )}
      </div>
    </div>
  );
});

FloatingButtons.displayName = 'FloatingButtons';

export default FloatingButtons;
